import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { TRANSFORM_BEFORE, TRANSFORM_AFTER } from './salesData';
export function ProblemSolutionSection() {
  return <section id="problema-solucion" className="bg-white py-11 sm:py-14" data-id="element-151" data-mp="2vazxcjhcxnlp">
      <div className="mx-auto max-w-md px-5 sm:max-w-3xl" data-id="element-152" data-mp="2gm3q2on4kem5">
        <h2 className="mx-auto max-w-[22ch] text-center font-display text-[1.32rem] font-extrabold uppercase leading-[1.12] tracking-tight text-charcoal sm:max-w-[30ch] sm:text-[1.85rem]" data-id="element-153" data-mp="2lilrpfn5rwu9">
          Hacer velas es una cosa.{' '}
          <span className="text-gold-deep" data-id="element-154" data-mp="3e7ixwke3i36n">Hacer velas que den ganancias es otra.</span>
        </h2>

        <p className="mx-auto mt-3 max-w-[40ch] text-center font-sans text-[0.86rem] leading-relaxed text-taupe sm:max-w-[56ch] sm:text-[0.94rem]" data-id="element-155" data-mp="307q76p2kjmyo">
          No alcanza con saber hacer una vela. Para convertirlo en un ingreso necesitás variedad,
          resultados consistentes y fórmulas que puedas repetir cada vez que llega un pedido.
        </p>

        <div className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-156" data-mp="yik7v5pte54p">
          <div className="rounded-2xl bg-cream p-4 sm:p-5" data-id="element-157" data-mp="yl6e920yyelc">
            <p className="font-display text-[0.62rem] font-bold uppercase tracking-editorial text-taupe" data-id="element-158" data-mp="tl0vycgla4fx">
              Lo que pasa hoy
            </p>
            <ul className="mt-3 space-y-2" data-id="element-159" data-mp="17hfgeogbzrb6">
              {TRANSFORM_BEFORE.map(item => <li key={item} className="flex gap-2 font-sans text-[0.83rem] leading-snug text-taupe" data-id="element-160" data-mp="13kjdkm911e4t">
                  <XIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-taupe/50" aria-hidden strokeWidth={3} data-id="element-161" data-mp="1hflhx4y86vfi" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl border border-gold bg-gold-soft p-4 sm:p-5" data-id="element-162" data-mp="1m8obhd3064vp">
            <p className="font-display text-[0.62rem] font-bold uppercase tracking-editorial text-gold-deep" data-id="element-163" data-mp="1mar8wi6hj0ag">
              Con las 200 fórmulas
            </p>
            <ul className="mt-3 space-y-2" data-id="element-164" data-mp="1vae4uogg3dw4">
              {TRANSFORM_AFTER.map(item => <li key={item} className="flex gap-2 font-sans text-[0.83rem] font-semibold leading-snug text-charcoal" data-id="element-165" data-mp="swzq9voxoxh1">
                  <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-gold" aria-hidden strokeWidth={3} data-id="element-166" data-mp="11wv282qbcwi4" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}